import amplitude from '@autopass-web/mochi-analytics';

import { environment } from '../environments/environment';

const AMPLITUDE_API_KEY = environment.amplitudeKey;

class AnalyticsService {
  constructor() {
    this.init();
  }
  // Init and setup functions
  public init = () => {
    amplitude.init(AMPLITUDE_API_KEY);
  };

  private _logEvent = (
    eventName: string,
    data: Record<string, unknown> = {},
  ) => {
    amplitude.log(eventName, data);
  };
  public memberInfoPageview = ({
    domain,
    path,
    query_string,
  }: {
    domain?: string;
    path?: string;
    query_string?: string;
  }) => {
    this._logEvent('會員資料頁-pageview', {
      domain,
      path,
      query_string,
    });
  };

  public memberInfoPhoneInputClick = () => {
    this._logEvent('會員資料頁-手機號碼輸入框_點擊');
  };

  public memberInfoMarketingOptedIn = (value) => {
    this._logEvent('會員資料頁-行銷同意條款勾選欄_點擊', {
      動作: value ? '勾選' : '取消',
    });
  };

  public memberInfoMarketingConsentClick = () => {
    this._logEvent('會員資料頁-行銷同意條款_點擊');
  };

  public memberInfoSendOtpClick = () => {
    this._logEvent('會員資料頁-手機號碼輸入框_傳送驗證碼_點擊');
  };

  public memberInfoEnterOtpClick = () => {
    this._logEvent('會員資料頁-輸入驗證碼_點擊');
  };

  public memberInfoEmailInputClick = () => {
    this._logEvent('會員資料頁-email 輸入框_點擊');
  };

  public memberInfoTermsClick = () => {
    this._logEvent('會員資料頁-服務條款_點擊');
  };

  public memberInfoPrivacyClick = () => {
    this._logEvent('會員資料頁-隱私權條款_點擊');
  };

  public memberInfoNextStepClick = () => {
    this._logEvent('會員資料頁-下一步_點擊');
  };

  public memberInfoPhoneRegisteredDialogRetryClick = () => {
    this._logEvent('會員資料頁-手機號碼已註冊 dialog_重新註冊_點擊');
  };

  public memberInfoPhoneRegisteredDialogGoToAppClick = () => {
    this._logEvent('會員資料頁-手機號碼已註冊 dialog_前往 APP_點擊');
  };

  public licenseInputPageview = () => {
    this._logEvent('車號輸入頁-pageview');
  };

  public licenseInputFieldClick = () => {
    this._logEvent('車號輸入頁-車牌輸入框_點擊');
  };

  public licenseVehicleTypeCarClick = () => {
    this._logEvent('車號輸入頁-車種選擇_汽車_點擊');
  };

  public licenseVehicleTypeMotorcycleClick = () => {
    this._logEvent('車號輸入頁-車種選擇_機車_點擊');
  };

  public licenseNextStepClick = () => {
    this._logEvent('車號輸入頁-下一步_點擊');
  };

  public licenseDuplicatedDialogConfirmClick = () => {
    this._logEvent('車號輸入頁-車號重複綁定 dialog_確認_點擊');
  };

  public creditCardSetupPageview = () => {
    this._logEvent('信用卡設定頁-pageview');
  };

  public creditCardNumberClick = () => {
    this._logEvent('信用卡設定頁-信用卡號碼_點擊');
  };

  public creditCardExpiryClick = () => {
    this._logEvent('信用卡設定頁-有效日期_點擊');
  };

  public creditCardCvcClick = () => {
    this._logEvent('信用卡設定頁-CVC_點擊');
  };

  public creditCardJoinMachiClick = () => {
    this._logEvent('信用卡設定頁-成為麻吉_點擊');
  };

  public creditCardAuthFailedBackClick = () => {
    this._logEvent('信用卡設定頁-信用卡授權失敗_返回編輯_點擊');
  };

  public paymentSuccessPageview = ({
    isNewUser,
    plateNumber,
    parkingLotName,
  }) => {
    this._logEvent('設定付款成功頁-Pageview', {
      全新用戶: isNewUser,
      車牌: plateNumber,
      場站名稱: parkingLotName,
    });
  };

  public paymentSuccessAdClick = () => {
    this._logEvent('設定付款成功頁-廣告版位_點擊');
  };

  public paymentSuccessLoginClick = ({ isNewUser, plateNumber, userId }) => {
    this._logEvent('設定付款成功頁-登入 APP_點擊', {
      全新用戶: isNewUser,
      車牌: plateNumber,
      user_id: userId,
    });
  };
}

export const analyticsService = new AnalyticsService();
